// extracted by mini-css-extract-plugin
export var series = "preview-module--series---NiTk";
export var fadein = "preview-module--fadein--ucMLS";